module.exports = __webpack_public_path__ + "img/tree-03-g-leaves.cfd38df0.png";